// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Alert,
    Button,
    Dialog,
    DialogHeader,
    DialogContent,
    DialogFooter,
    Heading,
    Text
} from '@locus-taxy/neo-ui';

type Props = {
    onConfirm: () => void,
    onDismiss: () => void,
    isOpen: boolean
};

const DisclaimerModal = ({
    onConfirm,
    onDismiss,
    isOpen
}: Props): React.Node => {
    const { t } = useTranslation('platform');

    return (
        <Dialog sticky width="xSmall" isOpen={isOpen} onDismiss={onDismiss}>
            <DialogHeader>
                <Heading truncated>
                    {t('settings.disclaimerModal.title')}
                </Heading>
            </DialogHeader>
            <DialogContent>
                <Text size="regular">
                    {t('settings.disclaimerModal.message')}
                </Text>
                <Alert
                    icon="error_outline"
                    palette="warning"
                    text={t('settings.disclaimerModal.disclaimer')}
                />
            </DialogContent>
            <DialogFooter>
                <Button onClick={onDismiss}>{t('translations:dismiss')}</Button>
                <Button
                    appearance="solid"
                    palette="primary"
                    onClick={onConfirm}
                >
                    {t('translations:confirm')}
                </Button>
            </DialogFooter>
        </Dialog>
    );
};

export default DisclaimerModal;
